export { default } from "./UserProfileApp";
